var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","outline":"","small":""},on:{"click":_vm.onRequestApproval}},[_vm._v(" Request Approval ")])
}
var staticRenderFns = []

export { render, staticRenderFns }